import React from "react";
import invariant from "invariant";
import PropTypes from "prop-types";
import Engine from "./engine";
import {EngineContext, TokenContext} from "./contexts";


export const Connect = ({ driver, config, children, fallback, redirectPath }) => {
    invariant(redirectPath.startsWith('/'), 'invalid path');
    // Pointer to the engine
    const ref = React.useRef();
    // State of the current token
    const [currentToken, setCurrentToken] = React.useState();

    // initialize the engine if it does not exist yet
    // eslint-disable-next-line
    const engine = ref.current || (ref.current = new Engine({
        // Extract the scheme + host from Accounts URL
        oAuthUrl: new URL(config.oAuthUrl).origin,
        clientId: config.clientId,
        onResolve: setCurrentToken,
        driver,
        redirectURI: `${window.location.protocol}//${window.location.host}${redirectPath}`,
    }));

    // Start the authentication proces
    React.useEffect(() => {
        engine.initialize();
    }, [engine]);
    // Inject the current value of the token and render the rest of the application
    return <EngineContext.Provider value={ engine }>
        {
            // Check if we have a token
            currentToken
                ? <TokenContext.Provider value={ currentToken } >
                    {children}
                </TokenContext.Provider>
                : fallback
        }
    </EngineContext.Provider>;
};

Connect.propTypes = {
    fallback: PropTypes.node,
    driver: PropTypes.object,
    children: PropTypes.node.isRequired,
    redirectPath: PropTypes.string.isRequired,
    config: PropTypes.shape({
        oAuthUrl: PropTypes.string.isRequired,
        clientId: PropTypes.string.isRequired,
    }).isRequired,
};
